import { render, staticRenderFns } from "./DataImports.vue?vue&type=template&id=4f0b3886&scoped=true&"
import script from "./DataImports.vue?vue&type=script&lang=js&"
export * from "./DataImports.vue?vue&type=script&lang=js&"
import style0 from "./DataImports.vue?vue&type=style&index=0&id=4f0b3886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0b3886",
  null
  
)

export default component.exports